import React, { createContext, useContext, useMemo } from 'react';
import { useConsensusAnalysis } from '../hooks/useConsensusAnalysis';

type ConsensusAnalysisContextValue = ReturnType<typeof useConsensusAnalysis>;

const ConsensusAnalysisContext = createContext<ConsensusAnalysisContextValue | null>(null);

interface ConsensusAnalysisProviderProps {
  comparisonId: string;
  children: React.ReactNode;
}

export function ConsensusAnalysisProvider({
  comparisonId,
  children
}: ConsensusAnalysisProviderProps) {
  const analysis = useConsensusAnalysis(comparisonId);

  const value = useMemo(() => analysis, [analysis]);

  return (
    <ConsensusAnalysisContext.Provider value={value}>
      {children}
    </ConsensusAnalysisContext.Provider>
  );
}

export function useConsensusAnalysisContext(): ConsensusAnalysisContextValue | null {
  return useContext(ConsensusAnalysisContext);
}
